module.exports = {
  entry: './src/apps/ai-solutions-advisor/index.tsx',
  shortcode: 'ai-solutions-advisor',
  title: 'AI Solutions Advisor',
  status: 'stable',
  description: 'Allows users to complete self assessment on AI product.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-ai-solutions-advisor-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
      'esla',
    ],
    org: 'digitalsales', // to filter the widget
    brand: 'security', // automation, dataai, security, storage, sustainability, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'ai-solutions-advisor', // the product name in the URL
    activatedCountryPages: [
      'us-en',
      'cn-zh',
      'br-pt',
      'de-de',
      'es-es',
      'fr-fr',
      'id-id',
      'it-it',
      'jp-ja',
      'kr-ko',
      'mx-es',
    ],
  },
};
